export const adminMenu = [
  { label: "Overview", route: "/", icon: "ri-dashboard-2-line" },
  { label: "Admins", route: "/admins", icon: "ri-shield-user-line" },
  { label: "Users", route: "/users", icon: "ri-group-line" },
  { label: "Bookings", route: "/bookings", icon: "ri-ticket-line" },
  { label: "Operators", route: "/operators", icon: "ri-user-2-line" },
  { label: "Reports", route: "/reports", icon: "ri-user-2-line" },
  { label: "Bus", route: "/buses", icon: "ri-bus-2-line" },
  { label: "City", route: "/city", icon: "ri-building-2-line" },
  { label: "My Profile", route: "/my_profile", icon: "ri-file-user-line" },
  { label: "Referrals", route: "/referrals", icon: "ri-user-shared-line" },
  { label: "FAQ", route: "/faqs", icon: "ri-building-2-line" },
];

export const superAdminMenu = [
  { label: "Overview", route: "/", icon: "ri-dashboard-2-line" },
  { label: "Admins", route: "/admins", icon: "ri-shield-user-line" },
  { label: "Users", route: "/users", icon: "ri-group-line" },
  { label: "Bookings", route: "/bookings", icon: "ri-ticket-line" },
  { label: "Pos", route: "/pos", icon: "ri-ticket-line" },
  { label: "Operators", route: "/operators", icon: "ri-user-2-line" },
  { label: "Reports", route: "/reports", icon: "ri-user-2-line" },

  { label: "Bus", route: "/buses", icon: "ri-bus-2-line" },
  {
    label: "Settlements",
    route: "/settlements",
    icon: "ri-secure-payment-line",
  },
  { label: "Transactions", route: "/transactions", icon: "ri-bank-card-line" },
  {
    label: "Coupon & Offers",
    route: "/coupon_and_offers",
    icon: "ri-file-text-line",
  },
  { label: "City", route: "/city", icon: "ri-building-2-line" },
  { label: "My Profile", route: "/my_profile", icon: "ri-file-user-line" },
  { label: "Referrals", route: "/referrals", icon: "ri-user-shared-line" },
  { label: "FAQ", route: "/faqs", icon: "ri-building-2-line" },
];
